import { creatorbase } from '@round/api';
import { useAggregatedPostStatsQueries } from '@round/creatorbase-helpers/api-hooks';

type CampaignStatsEntry = {
    data: creatorbase.AggregatedPostStats | null;
    isFetching: boolean;
    isError: boolean;
};

type CampaignStatsData = {
    [campaignId: number]: CampaignStatsEntry;
};

type Result = {
    data: CampaignStatsData;
    loadingCampaignIds: number[];
};

export function useProjectCampaignsStats(campaignIds: number[]): Result {
    return useAggregatedPostStatsQueries(
        campaignIds.map((campaignId) => ({ params: { campaign_id: campaignId } })),
        {
            combine: (results) => {
                const data: CampaignStatsData = {};
                const loadingCampaignIds: number[] = [];

                campaignIds.forEach((campaignId, index) => {
                    const query = results[index];
                    data[campaignId] = {
                        data: query?.data ?? null,
                        isFetching: query?.isFetching ?? false,
                        isError: query?.isError ?? false,
                    };

                    // Only mark as loading on the initial fetch (no data yet) so background
                    // refetches don't flash existing stats back to skeletons.
                    if (query?.isPending) {
                        loadingCampaignIds.push(campaignId);
                    }
                });

                return { data, loadingCampaignIds };
            },
        }
    );
}
